import api from "./config";

export default {
  terms: async (userId: string) => {
    const { data } = await api.get(`/api/accept-terms/${userId}`);
    return data;
  },
  acceptTerms: async (userId: string) => {
    const { data } = await api.post(`/api/accept-terms/${userId}`);
    return data;
  },
  delete: async (userId: string) => {
    const { data } = await api.delete(`/api/accept-terms/${userId}`);
    return data;
  },
};
